import React from "react";
import CloseIcon from "icons/close.svg";

function ModalHeader({
  title = "",
  onClose = () => {
    return;
  },
  subTitle = "",
  showCloseButton = true,
  verifyCondition = false,
}) {
  return (
    <div
      className={`pt-6 flex flex-top flex-between ${
        !verifyCondition ? "pb-6 " : ""
      }`}
    >
      <div className="flex flex-column">
        <div className={`fw-600 c-primary-0 lpf-40`}>{title}</div>
        {subTitle && <div className="c-success-500 fs-3 mt-2">{subTitle}</div>}
      </div>
      {showCloseButton && (
        <div
          style={{ borderRadius: "14px" }}
          className={`pb-1 px-1 flex flex-middle nmx-1`}
          onClick={onClose}
        >
          <CloseIcon
            height={22}
            width={22}
            className=" c-pointer c-neutral-900"
          />
        </div>
      )}
    </div>
  );
}
export default ModalHeader;
